import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { ShoppingCart } from "lucide-react";
import { useCart } from "@/context/CartContext";

/**
 * Renders the cart icon in the header. Clicking navigates to the dedicated
 * /cart page (required for Google Merchant Center & deep linking).
 * The legacy drawer/sheet has been replaced with a real route.
 */
export default function CartDrawer({ variant = "desktop" }) {
  const { count } = useCart();
  const testIdSuffix = variant === "mobile" ? "-mobile" : "";

  return (
    <Link
      to="/cart"
      className="relative inline-flex items-center justify-center p-2 hover:bg-amethyst-50 rounded-lg transition-colors"
      aria-label="Open cart"
      data-testid={`cart-toggle-btn${testIdSuffix}`}
    >
      <ShoppingCart className="w-5 h-5 text-amethyst-700" strokeWidth={1.5} />
      {count > 0 && (
        <Badge
          className="absolute -top-1 -right-1 h-5 min-w-[20px] px-1 bg-gold-500 text-white border-2 border-white text-[10px]"
          data-testid={`cart-count${testIdSuffix}`}
        >
          {count}
        </Badge>
      )}
    </Link>
  );
}
